/**
 * @file 路由配置页
 */

import Vue from 'vue'
import Router from 'vue-router'

// 首页
const Home = () => import('./modules/home/index.vue');

// 工作台
const Workbench = () => import('./modules/workbench/Index.vue');
const MyProcess = () => import('./modules/workbench/myProcess/Index.vue');
const MyProcessIndex = () => import('./modules/workbench/myProcess/MyProcessIndex.vue');
const MyPedding = () => import('./modules/workbench/myProcess/myPedding/Index.vue'); // 待办tab页
const MyStart = () => import('./modules/workbench/myProcess/myStart/Index.vue'); // 我发起的tab页
const MyApprove = () => import('./modules/workbench/myProcess/myApprove/Index.vue'); // 我审批的tab页
// const MyDraft = () => import ('./modules/workbench/myProcess/myDraft/Index.vue'); // 我审批的tab页
const ProcessQuery = () => import('./modules/workbench/processQuery/index.vue'); // 流程查询
// 工作台页面指向新父组件 月度资金计划/年度资金计划/年度预算编制/季度资金计划 填报/审批/查看
// const PeddingMonthFill = () =>
//     import ('./modules/workbench/myProcess/taskFlow/someShells/myPedding/month/fill.vue'); // 月度资金计划填报

// 业务预算明细
const BusinessBudget = () => import('./modules/businessBudget/index.vue');
const BusinessBudgetDetail = () => import('./modules/businessBudget/budgetDetail/index.vue');
// 业务预算明细tab页
const BusinessBudgetDetailBudget = () => import('./modules/businessBudget/budgetDetail/tabPages/budget.vue');
// 业务预算执行tab页
const BusinessBudgetDetailExecution = () => import('./modules/businessBudget/budgetDetail/tabPages/execution.vue');
// 业务预算执行-非经营相关tab页
const BusinessBudgetDetailexecutionNonBusiness = () => import('./modules/businessBudget/budgetDetail/tabPages/executionNonBusiness.vue');
// 借款余额tab页
const BusinessBudgetDetailLoanBalance = () => import('./modules/businessBudget/budgetDetail/tabPages/loanBalance.vue');
// 费用名称管理
const BusinessExpenseName = () => import('./modules/businessBudget/expenseName/index.vue');
// 归口人管理
const BusinessPersonInCharge = () => import('./modules/businessBudget/personInCharge/index.vue');
// 操作日志
const BusinessOperateLog = () => import('./modules/businessBudget/operateLog/index.vue');



// 预算分析报表
const BudgetReport = () => import('./modules/budgetReport/index.vue');
// 预算分析报表 总表
const BudgetReportSummary = () => import('./modules/budgetReport/summary/index.vue');
// 预算分析报表 分校按大类
const BudgetReportSchoolByCategory = () => import('./modules/budgetReport/SchoolByCategory/index.vue');
// 预算分析报表 分校按明细
const BudgetReportSchoolByDetail = () => import('./modules/budgetReport/SchoolByDetail/index.vue');
// 预算分析报表 总部职能按大类
const BudgetReportHeadquarterByCategory = () => import('./modules/budgetReport/HeadquarterByCategory/index.vue');
// 预算分析报表 总部职能按部门
const BudgetReportHeadquarterByDept = () => import('./modules/budgetReport/HeadquarterByDept/index.vue');
// 预算分析报表 产品线
const BudgetReportProductLine = () => import('./modules/budgetReport/ProductLine/index.vue');
// 预算分析报表 报告-按部门
const BudgetReportReportByDept = () => import('./modules/budgetReport/ReportByDept/index.vue');
// 预算分析报表 报告-按归口
const BudgetReportReportByHost = () => import('./modules/budgetReport/ReportByHost/index.vue');
// 预算分析报表 报告-按产品线
const BudgetReportReportByProductLine = () => import('./modules/budgetReport/ReportByProductLine/index.vue');

// const halfYearTask = () => import ('./modules/yearBudget/assignTask/organize/halfYearTask/index.vue');
// 年度预算编制任务 详情 包含审批
const HalfYearTaskDetail = () => import('./modules/yearBudget/assignTask/organize/halfYearTask/detail.vue');
const TaskDetailByMonth = () => import('./modules/yearBudget/assignTask/organize/halfYearTask/detailByMonth.vue');


// // 半年度管理顶层路由
// const halfYearBudgetIndex = () => import ('./modules/halfYear/index.vue');
// const HalfYearBudgetDetailList = () => import ('./modules/halfYear/detailList/index.vue'); 


// 年度预算调整顶层路由
const YearBudgetIndex = () => import('./modules/yearBudget/index.vue');
// 年度编制任务发起
const AssignYearBudgetTask = () => import('./modules/yearBudget/assignTask/index.vue');
// 年度编制任务发起 选择模板
const organizeStartYear = () => import('./modules/yearBudget/assignTask/organize/startYear/index.vue');
// 年度编制任务列表 选择模板
const organizeYearList = () => import('./modules/yearBudget/assignTask/organize/yearTaskList/index.vue');

// 年度预算调整申请
const YearBudgetAdjust = () => import('./modules/yearBudget/alterList/index.vue');
// 年度预算调整列表
// const YearBudgetAdjustList = () => import ('./modules/yearBudget/alterList/list.vue'); 
// 年度预算调整列表详情
const YearBudgetAdjustDetail = () => import('./modules/yearBudget/alterList/detail.vue');
// 年度预算明细列表
// const YearBudgetAdjustDetailList = () => import ('./modules/yearBudget/detailList/index.vue');
const YearBudgetList = () => import('./modules/yearBudget/budgetList/index.vue');
// 预算执行数据
const ExecBudgetList = () => import('./modules/yearBudget/budgetList/detail.vue');
// 预算管控配置
const BudgetControl = () => import('./modules/yearBudget/budgetControl/index.vue');

// 公司管理
// const Company = () => import('./modules/InfoPlatform/company/Index.vue');
// 会计科目
const AccountingTitle = () => import('./modules/InfoPlatform/accounting-title/index.vue');

// 实际数据管理
const ActualDataManage = () => import('./modules/actualDataManage/index.vue');
// 业绩考核数据管理
const PerformanceEvaluation = () => import('./modules/actualDataManage/performanceEvaluation/index.vue');

// 系统管理
const Role = () => import('./modules/systemSetting/role/index')
const Menu = () => import('./modules/systemSetting/menu/index')
const User = () => import('./modules/systemSetting/user/index');
// const FirstDept = () => import ('./modules/systemSetting/firstDept/index');
const DepartmentSelect = () => import('./modules/systemSetting/departmentSelect/index');
// const BudgetType = () => import ('./modules/systemSetting/budgetType/index'); 

const Page403 = () => import('./modules/systemSetting/errorPage/403.vue');
Vue.use(Router)
export default new Router({
    mode: 'history',
    routes: [ //    路由详情
        {
            path: '/',
            redirect: '/myProcess/myProcessIndex/myPedding',
        },
        // 下面是首页页面
        // {
        //     path: '/Home',
        //     name: 'Home',
        //     meta: {
        //         title: '首页',
        //     },
        //     component: Home,
        // },
        {
            path: '/403',
            name: 'page403',
            meta: {
                title: '',
            },
            component: Page403,
        },
        // {
        //     path: '/halfYearTask',
        //     name: 'halfYearTask',
        //     meta: {
        //         title: '年度预算编制任务',
        //         requireAuth: false,
        //         // authName: 'year',
        //         // auth: 'assignTask',
        //     },
        //     component: halfYearTask,

        // },



        // 下面是工作台菜单页面
        {
            path: '/workbench',
            name: 'workbench',
            redirect: '/myProcess/myProcessIndex/myPedding',
            meta: {
                title: '工作台',
                // requireAuth: false
            },
            component: Workbench,
            children: [
                {
                    path: '/myProcess',
                    component: MyProcess,
                    redirect: '/myProcess/myProcessIndex/myPedding',
                    name: 'myProcess',
                    meta: {
                        title: '我的流程',
                        // requireAuth: false
                    },

                    children: [
                        {
                            path: 'myProcessIndex',
                            // component: MyProcessIndex,
                            component: MyProcessIndex,
                            redirect: '/myProcess/myProcessIndex/myPedding',
                            name: 'myProcessIndex',
                            children: [

                                {
                                    path: 'myPedding',
                                    component: MyPedding,
                                    name: 'myPedding',
                                    meta: {
                                        title: '待办',
                                        requireAuth: true,
                                        authName: 'workBreah',
                                        auth: 'myProcess',
                                    },
                                    children: [
                                        {
                                            path: 'yearBudgetAdjustDetailFromPedding',
                                            name: 'yearBudgetAdjustDetailFromPedding',
                                            meta: {
                                                title: '年度预算调整申请',
                                                requireAuth: true,
                                                authName: 'workBreah',
                                                auth: 'myProcess',
                                            },
                                            component: YearBudgetAdjustDetail,
                                        },
                                        {
                                            path: 'halfYearTaskDetailFromPedding',
                                            name: 'halfYearTaskDetailFromPedding',
                                            meta: {
                                                title: '年度预算编制任务',
                                                requireAuth: true,
                                                authName: 'workBreah',
                                                auth: 'myProcess',
                                            },
                                            component: HalfYearTaskDetail,
                                        },
                                        {
                                            path: 'taskDetailByMonthFromPedding',
                                            name: 'taskDetailByMonthFromPedding',
                                            meta: {
                                                title: '年度预算编制任务',
                                                requireAuth: true,
                                                authName: 'workBreah',
                                                auth: 'myProcess',
                                            },
                                            component: TaskDetailByMonth,
                                        },
                                    ]
                                },
                                {
                                    path: 'myStart',
                                    component: MyStart,
                                    name: 'myStart',
                                    meta: {
                                        title: '我发起的',
                                        requireAuth: true,
                                        authName: 'workBreah',
                                        auth: 'myProcess',
                                    },
                                    children: [
                                        {
                                            path: 'yearBudgetAdjustDetailFromStart',
                                            name: 'yearBudgetAdjustDetailFromStart',
                                            meta: {
                                                title: '年度预算调整申请',
                                                requireAuth: true,
                                                authName: 'workBreah',
                                                auth: 'myProcess',
                                            },
                                            component: YearBudgetAdjustDetail
                                        },
                                        {
                                            path: 'halfYearTaskDetailFromStart',
                                            name: 'halfYearTaskDetailFromStart',
                                            meta: {
                                                title: '年度预算编制任务',
                                                requireAuth: true,
                                                authName: 'workBreah',
                                                auth: 'myProcess',
                                            },
                                            component: HalfYearTaskDetail,
                                        },
                                        {
                                            path: 'taskDetailByMonthFromStart',
                                            name: 'taskDetailByMonthFromStart',
                                            meta: {
                                                title: '年度预算编制任务',
                                                requireAuth: true,
                                                authName: 'workBreah',
                                                auth: 'myProcess',
                                            },
                                            component: TaskDetailByMonth,
                                        },
                                    ]
                                },
                                {
                                    path: 'myApprove',
                                    component: MyApprove,
                                    name: 'myApprove',
                                    meta: {
                                        title: '我审批的',
                                        requireAuth: true,
                                        authName: 'workBreah',
                                        auth: 'myProcess',
                                    },
                                    children: [
                                        {
                                            path: 'yearBudgetAdjustDetailFromApprove',
                                            name: 'yearBudgetAdjustDetailFromApprove',
                                            meta: {
                                                title: '年度预算调整申请',
                                                requireAuth: true,
                                                authName: 'workBreah',
                                                auth: 'myProcess',
                                            },
                                            component: YearBudgetAdjustDetail
                                        },
                                        {
                                            path: 'halfYearTaskDetailFromApprove',
                                            name: 'halfYearTaskDetailFromApprove',
                                            meta: {
                                                title: '年度预算编制任务',
                                                requireAuth: true,
                                                authName: 'workBreah',
                                                auth: 'myProcess',
                                            },
                                            component: HalfYearTaskDetail,
                                        },
                                        {
                                            path: 'taskDetailByMonthFromApprove',
                                            name: 'taskDetailByMonthFromApprove',
                                            meta: {
                                                title: '年度预算编制任务',
                                                requireAuth: true,
                                                authName: 'workBreah',
                                                auth: 'myProcess',
                                            },
                                            component: TaskDetailByMonth,
                                        }
                                    ]
                                },
                                // {
                                //     path: "myDraft",
                                //     component: MyDraft,
                                //     name: "myDraft",
                                //     meta: {
                                //         title: "草稿",
                                //         keepAlive: true
                                //     }
                                // },

                            ]
                        }]
                },
                {
                    path: 'processQuery',
                    component: ProcessQuery,
                    name: 'processQuery',
                    meta: {
                        title: '流程查询',
                        requireAuth: true,
                        authName: 'workBreah',
                        auth: 'processList',
                    },
                    children: [
                        {
                            path: 'yearBudgetAdjustDetailFromProcess',
                            name: 'yearBudgetAdjustDetailFromProcess',
                            meta: {
                                title: '年度预算调整申请',
                                requireAuth: true,
                                authName: 'workBreah',
                                auth: 'processList',
                            },
                            component: YearBudgetAdjustDetail
                        },
                        {
                            path: 'halfYearTaskDetailFromProcess',
                            name: 'halfYearTaskDetailFromProcess',
                            meta: {
                                title: '年度预算编制任务',
                                requireAuth: true,
                                authName: 'workBreah',
                                auth: 'processList',
                            },
                            component: HalfYearTaskDetail,
                        },
                        {
                            path: 'taskDetailByMonthFromProcess',
                            name: 'taskDetailByMonthFromProcess',
                            meta: {
                                title: '年度预算编制任务',
                                requireAuth: true,
                                authName: 'workBreah',
                                auth: 'processList',
                            },
                            component: TaskDetailByMonth,
                        },
                    ]
                },
            ],
        },

        {
            path: '/businessBudget',
            name: 'businessBudget',
            meta: {
                title: '业务预算管理',
            },
            component: BusinessBudget,
            children: [
                {
                    path: 'budgetDetail',
                    name: 'businessBudgetBudgetDetail',
                    component: BusinessBudgetDetail,
                    meta: {
                        title: '业务预算明细',
                        requireAuth: true,
                        authName: 'businessBudget',
                        auth: 'budgetDetail',
                    },
                    children: [
                        {
                            path: 'budget',
                            name: 'businessBudgetDetail',
                            component: BusinessBudgetDetailBudget,
                            meta: {
                                title: '业务预算',
                            },
                        },
                        {
                            path: 'execution',
                            name: 'businessBudgetExecutiont',
                            component: BusinessBudgetDetailExecution,
                            meta: {
                                title: '业务预算执行',
                            },
                        },
                        {
                            path: 'executionNonBusiness',
                            name: 'businessBudgetExecutionNonBusiness',
                            component: BusinessBudgetDetailexecutionNonBusiness,
                            meta: {
                                title: '业务预算执行-非经营相关',
                            },
                        },
                        {
                            path: 'loanBalance',
                            name: 'businessBudgetLoanBalance',
                            component: BusinessBudgetDetailLoanBalance,
                            meta: {
                                title: '借款余额',
                            },
                        }
                    ],
                },
                {
                    path: 'departmentSelect',
                    name: 'departmentSelect',
                    meta: {
                        title: '部门类型设置',
                        requireAuth: true,
                        authName: 'businessBudget',
                        auth: 'departmentSelect',
                    },
                    component: DepartmentSelect
                },
                {
                    path: 'expenseName',
                    name: 'expenseName',
                    meta: {
                        title: '借款余额同步管理',
                        requireAuth: true,
                        authName: 'businessBudget',
                        auth: 'expenseName',
                    },
                    component: BusinessExpenseName,
                },
                {
                    path: 'personInCharge',
                    name: 'personInCharge',
                    meta: {
                        title: '归口人管理',
                        requireAuth: true,
                        authName: 'businessBudget',
                        auth: 'personInCharge',
                    },
                    component: BusinessPersonInCharge,
                },
                {
                    path: 'operateLog',
                    name: 'operateLog',
                    meta: {
                        title: '操作日志',
                        requireAuth: true,
                        authName: 'businessBudget',
                        auth: 'operateLog',
                    },
                    component: BusinessOperateLog,
                },
            ],
        },
        {
            path: '/budgetReport',
            name: 'BudgetReport',
            meta: {
                title: '预算分析报表',
            },
            component: BudgetReport,
            children: [
                {
                    path: 'summary',
                    name: 'budgetReportSummary',
                    component: BudgetReportSummary,
                    meta: {
                        title: '总表',
                        requireAuth: true,
                        authName: 'budgetReport',
                        auth: 'summary',
                    },
                },
                {
                    path: 'schoolByCategory',
                    name: 'budgetReportSchoolByCategory',
                    component: BudgetReportSchoolByCategory,
                    meta: {
                        title: '分校按大类',
                        requireAuth: true,
                        authName: 'budgetReport',
                        auth: 'schoolByCategory',
                    },
                },
                {
                    path: 'schoolByDetail',
                    name: 'budgetReportSchoolByDetail',
                    component: BudgetReportSchoolByDetail,
                    meta: {
                        title: '分校按明细',
                        requireAuth: true,
                        authName: 'budgetReport',
                        auth: 'schoolByDetail',
                    },
                },
                {
                    path: 'headquarterByCategory',
                    name: 'budgetReportHeadquarterByCategory',
                    component: BudgetReportHeadquarterByCategory,
                    meta: {
                        title: '总部职能按大类',
                        requireAuth: true,
                        authName: 'budgetReport',
                        auth: 'headquarterByCategory',
                    },
                },
                {
                    path: 'headquarterByDept',
                    name: 'budgetReportHeadquarterByDept',
                    component: BudgetReportHeadquarterByDept,
                    meta: {
                        title: '总部职能按部门',
                        requireAuth: true,
                        authName: 'budgetReport',
                        auth: 'headquarterByDept',
                    },
                },
                {
                    path: 'productLine',
                    name: 'budgetReportProductLine',
                    component: BudgetReportProductLine,
                    meta: {
                        title: '产品线',
                        requireAuth: true,
                        authName: 'budgetReport',
                        auth: 'productLine',
                    },
                },
                {
                    path: 'reportByDept',
                    name: 'budgetReportReportByDept',
                    component: BudgetReportReportByDept,
                    meta: {
                        title: '报告-按部门',
                        requireAuth: true,
                        authName: 'budgetReport',
                        auth: 'reportByDept',
                    },
                },
                {
                    path: 'reportByHost',
                    name: 'budgetReportReportByHost',
                    component: BudgetReportReportByHost,
                    meta: {
                        title: '报告-按归口',
                        requireAuth: true,
                        authName: 'budgetReport',
                        auth: 'reportByHost',
                    },
                },
                {
                    path: 'reportByProductLine',
                    name: 'budgetReportReportByProductLine',
                    component: BudgetReportReportByProductLine,
                    meta: {
                        title: '报告-按产品线',
                        requireAuth: true,
                        authName: 'budgetReport',
                        auth: 'reportByProductLine',
                    },
                },
            ],
        },
        // {
        //     path: '/halfYearBudget',
        //     name: 'halfYearBudget',
        //     meta: {
        //         title: '半年度管理',
        //         requireAuth: true,
        //         authName: 'halfyear',
        //         auth: 'list',
        //     },
        //     component: halfYearBudgetIndex,
        //     redirect: '/halfYearBudget/halfYearBudgetDetailList',
        //     children: [
        //         {
        //             path: 'halfYearBudgetDetailList',
        //             name: 'halfYearBudgetDetailList',
        //             meta: {
        //                 title: '半年度明细查询',
        //                 requireAuth: true,
        //                 authName: 'halfyear',
        //                 auth: 'list',
        //             },
        //             component: HalfYearBudgetDetailList
        //         },
        //     ]
        // },
        {
            path: '/actualDataManage',
            name: 'ActualDataManage',
            meta: {
                title: '实际数据管理',
                requireAuth: true,
                authName: 'actualDataManage',
                auth: 'list',
            },
            component: ActualDataManage,
            redirect: '/actualDataManage/performanceEvaluation',
            children: [
                {
                    path: 'performanceEvaluation',
                    name: 'PerformanceEvaluation',
                    meta: {
                        title: '业绩考核数据管理',
                        requireAuth: true,
                        authName: 'actualDataManage',
                        auth: 'list',
                    },
                    component: PerformanceEvaluation
                },
            ]
        },

        {
            path: '/yearBudgetHome',
            name: 'yearBudgetHome',
            meta: {
                title: '年度预算管理',
            },
            component: YearBudgetIndex,
            redirect: '/yearBudgetHome/yearBudgetAdjust',
            children: [
                {
                    path: 'yearBudgetList',
                    name: 'yearBudgetList',
                    meta: {
                        title: '预算明细查询',
                    },
                    component: YearBudgetList,
                    children: [
                        {
                            path: 'execBudgetList',
                            name: 'execBudgetList',
                            meta: {
                                title: '预算执行数据',
                            },
                            component: ExecBudgetList,

                        },
                        {
                            path: 'forzenBudgetList',
                            name: 'forzenBudgetList',
                            meta: {
                                title: '预算冻结数据',
                            },
                            component: ExecBudgetList,

                        },
                    ]
                },
                {
                    path: 'assignYearBudgetTask',
                    name: 'assignYearBudgetTask',
                    meta: {
                        title: '年度编制任务发起',
                        requireAuth: true,
                        authName: 'year',
                        auth: 'satrtBudget',
                    },
                    component: AssignYearBudgetTask,
                    children: [
                        {
                            path: 'startYear',
                            name: 'organizeStartYear',
                            meta: {
                                title: '年度编制任务发起',
                                requireAuth: true,
                                authName: 'year',
                                auth: 'satrtBudget',
                            },
                            component: organizeStartYear,
                        },
                        {
                            path: 'yearList',
                            name: 'organizeYearList',
                            meta: {
                                title: '年度编制任务列表',
                                requireAuth: true,
                                authName: 'year',
                                auth: 'satrtBudget',
                            },
                            component: organizeYearList,
                            children: [
                                {
                                    path: 'halfYearTaskDetail',
                                    name: 'halfYearTaskDetail',
                                    meta: {
                                        title: '年度预算编制任务',
                                        requireAuth: true,
                                        authName: 'year',
                                        auth: 'satrtBudget',
                                    },
                                    component: HalfYearTaskDetail,
                                },
                                {
                                    path: 'taskDetailByMonth',
                                    name: 'taskDetailByMonth',
                                    meta: {
                                        title: '年度预算编制任务',
                                        requireAuth: true,
                                        authName: 'year',
                                        auth: 'satrtBudget',
                                    },
                                    component: TaskDetailByMonth,
                                },
                            ]
                        }
                    ]
                },
                {
                    path: 'yearBudgetAdjust',
                    name: 'yearBudgetAdjust',
                    meta: {
                        title: '年度预算调整申请',
                        requireAuth: true,
                        authName: 'year',
                        auth: 'alterYearBudgetApply',
                    },
                    component: YearBudgetAdjust
                },
                {
                    path: 'budgetControl',
                    name: 'budgetControl',
                    meta: {
                        title: '预算管控配置',
                        requireAuth: true,
                        authName: 'year',
                        auth: 'budgetControl',
                    },
                    component: BudgetControl
                },
                // {
                //     path: 'yearBudgetAdjustList',
                //     name: 'yearBudgetAdjustList',
                //     meta: {
                //         title: '年度预算调整列表',
                //         requireAuth: true,
                //         authName: 'year',
                //         auth: 'alterYearBudgetApply',
                //     },
                //     component: YearBudgetAdjustList,
                //     children: [
                //     ]
                // },
                // {
                //     path: 'yearBudgetAdjustDetailList',
                //     name: 'yearBudgetAdjustDetailList',
                //     meta: {
                //         title: '年度预算明细查询',
                //         requireAuth: true,
                //         authName: 'year',
                //         auth: 'budgetDetailList',
                //     },
                //     component: YearBudgetAdjustDetailList
                // },
            ]
        },
        // {
        //     path: '/company',
        //     name: 'company',
        //     meta: {
        //         title: '公司管理',
        //         requireAuth: false,
        //     },
        //     component: Company
        // },
        {
            path: '/accountingTitle',
            name: 'AccountingTitle',
            meta: {
                title: '会计科目管理',
                requireAuth: true,
                authName: 'accountingTitle',
                auth: 'list',
            },
            component: AccountingTitle
        },
        {
            path: '/role',
            name: 'role',
            meta: {
                title: '角色管理',
                requireAuth: true,
                authName: 'system',
                auth: 'role',
            },
            component: Role
        },
        {
            path: '/user',
            name: 'user',
            meta: {
                title: '用户管理',
                requireAuth: true,
                authName: 'system',
                auth: 'user',
            },
            component: User
        },
        {
            path: '/menu',
            name: 'menu',
            meta: {
                title: '菜单管理',
                requireAuth: true,
                authName: 'system',
                auth: 'menu',
            },
            component: Menu
        },
        // {
        //     path: '/firstDept',
        //     name: 'firstDept',
        //     meta: {
        //         title: '一级部门管理',
        //         // requireAuth: true,
        //         // authName: 'system',
        //         // auth: 'menu',
        //     },
        //     component: FirstDept
        // },

        // {
        //     path: '/budgetType',
        //     name: 'budgetType',
        //     meta: {
        //         title: '预算大类管理',
        //         // requireAuth: true,
        //         // authName: 'system',
        //         // auth: 'menu',
        //     },
        //     component: BudgetType
        // },


    ]
})